import { BaseReviewResponse } from './review.type';
import { BasePromptResponse, FormatReviewContent } from './prompt.type';

export interface ReviewAutoProcessResponse {
    type: 'review-auto-process';
    id: number;
    attributes: BaseReviewAutoProcessResponse;
}

/*******************************/

export interface BaseReviewAutoProcessResponse {
    review_auto_process_id: number;
    ai_response: object;
    ai_process: boolean;
    auto_published: boolean;
    is_review_response: boolean;
    issues_identified: string;
    review: BaseReviewResponse | any;
    prompt: BasePromptResponse | any;
}

export interface AutoProcessReviewEvent {
    review_id: number;
    is_test_flow: boolean;
    total_executions: number;
    content_format: FormatReviewContent;
    current_execution: number;
    prompt_id: number;
    prompt: BasePromptResponse;
    /** If true, the request came from PAL autopublish cron; PAL rating rules apply only then. */
    from_pal_autopublish_cron?: boolean;
}

export interface ReviewAutoProcessSummary {
    general_summary: string;

    issues_summary: string;

    issues_pii: { pii_type: string; identified_words: string[] }[];
}

export interface PublishDecisionFlags {
    passed_ai_publish: boolean | null;
    passed_minimum_score: boolean | null;
    passed_pii_validation: boolean;
}

export interface PublishDecisionResponse {
    auto_published: boolean | null;
    decisions: PublishDecisionFlags;
    data: {
        score: number | null;
        min_score: number;
        reason: string | null;
        pii: object | null;
    };
}

export const DEFAULT_GPT_MODEL = 'gpt-4o-mini';

export const DEFAULT_GPT_TEMP = 0;
